import {
  Flex,
  Box,
  Text,
  UnorderedList,
  ListItem,
  useDisclosure,
  SlideFade,
} from "@chakra-ui/react";
import Head from "next/head";
import Image from "components/Image";
import Layout from "components/Layout";
import Button from "components/Button";
import logo101PayImage from "../../../public/logo-101pay.png";
import bgCircle1 from "../../../public/products/bg-circle-1.png";
import bgCircle2 from "../../../public/products/bg-circle-2.png";
import bgCircle3 from "../../../public/products/bg-circle-3.png";
import bgCircleMobile1 from "../../../public/products/bg-circle-mobile-1.png";
import bgCircleMobile2 from "../../../public/products/bg-circle-mobile-2.png";
import playCircleIcon from "../../../public/home/icon-play-circle.svg";
import bankApiImage from "../../../public/home/image-bank-api.png";
import neoBankImage from "../../../public/home/image-neobank-sdk.png";
import preview101PayImage from "../../../public/products/image-preview-101-pay.png";
import previewDigibankImage from "../../../public/products/image-preview-digibank.png";
import logoDigibankImage from "../../../public/home/logo-digibank.png";
import iconCheck from "../../../public/products/icon-check.svg";
import { useRouter } from "next/router";
import ModalWatchVideo from "containers/ModalWatchVideo";
import { useState } from "react";

const boxes = [
  {
    title: "Discover",
    description: "Understand your vision for your business and products",
  },
  {
    title: "Partner and Co-Create",
    description: "Leverage our platform to rapidly evolve the products",
  },
  {
    title: "Launch",
    description: "Launch the product to market quickly and continue to refine",
  },
];

const productsPreviewData = [
  {
    key: "101-pay",
    link: "https://www.youtube.com/embed/q_0k8txaADs",
    logo: logo101PayImage,
    previewImage: preview101PayImage,
    imageAltText: "101Pay application development",
    description:
      "With 101 Pay, SMEs can manage their invoicing & banking in one app.",
    lists: [
      "Streamline the invoice generation process",
      "Help customers make timely payments",
      "Manage your finances better! ",
    ],
  },
  {
    key: "digibank",
    link: "",
    logo: logoDigibankImage,
    previewImage: previewDigibankImage,
    imageAltText: "DigiBank Webapp on desktop and mobile",
    description:
      "DigiBank is a pre-built solution that supports corporate and personal banking use cases.",
    lists: [
      "Available as a Platform as a Service (PaaS)",
      "Equipped with a range of web and mobile app front-ends",
      "Can be leveraged as a white-label solution",
    ],
  },
];

const Products = () => {
  const router = useRouter();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [urlVideo, setUrlVideo] = useState<string>("");

  const handleOpenWatchVideoModal = (url: string): void => {
    setUrlVideo(url);
    onOpen();
  };

  return (
    <Layout>
      <Head>
        <title>101Digital | Products</title>
      </Head>
      <ModalWatchVideo isOpen={isOpen} onClose={onClose} src={urlVideo} />
      <SlideFade
        in={true}
        offsetY="50px"
        transition={{ enter: { duration: 1 } }}
      >
        <Text
          as="h1"
          textStyle="h1"
          textAlign={["center", null, null, null, null, "left"]}
          display="flex"
          flexDir={["column", null, null, null, null, "row"]}
          mt={["45px", null, null, null, null, "132px"]}
          mb={["13px", null, null, null, null, 8]}
        >
          <Text>Digital Platforms</Text>
          <Text color="secondary" ml={4}>
            in Months
          </Text>
        </Text>
      </SlideFade>
      <Text
        textStyle="paragraphHighlighted"
        textAlign={["center", null, null, null, null, "left"]}
        px={["61px", null, null, null, null, 0]}
        mb={["70px", null, null, null, null, "200px"]}
        fontWeight={300}
      >
        Reduce go-to-market timelines from years to months!
      </Text>
      <Box
        position="relative"
        mx="auto"
        maxW="1000px"
        w="100%"
        mb={["0", null, null, "100px"]}
      >
        <Box
          pos="absolute"
          display={["none", "block"]}
          right="-459px"
          top="0"
          zIndex="-1"
        >
          <Image src={bgCircle1} alt="101Pay" />
        </Box>
        <Box
          pos="absolute"
          display={["block", "none"]}
          left="0"
          top="230px"
          zIndex="-1"
        >
          <Image src={bgCircleMobile1} alt="101Pay" />
        </Box>
        <Box
          pos="absolute"
          display={["block", "none"]}
          left="0"
          bottom="280px"
          zIndex="-1"
        >
          <Image src={bgCircleMobile2} alt="101Pay" />
        </Box>
        <Flex
          align="center"
          justify="space-between"
          flexDir={["column", null, null, "row"]}
          px="16px"
        >
          <SlideFade
            in={true}
            offsetX="-200px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box
              background="#fff"
              flex={["0 0 265px", null, null, "0 0 400px"]}
              maxW={["265px", null, null, "400px"]}
              p={["33px 27px", null, null, "50px 40px"]}
              borderRadius="20px"
              boxShadow="0px 0px 5px rgba(0, 0, 0, 0.25)"
            >
              <Text
                textStyle="paragraph"
                fontSize={["18px", null, null, "26px"]}
                color="#14142B"
                mb="10px"
              >
                Service
              </Text>
              <Text
                textStyle="h3"
                lineHeight="1.3"
                fontSize={["24px", null, null, "36px"]}
                fontWeight="bold"
                color="#102542"
                mb="40px"
              >
                Neobank SDK: <br /> Neobank as a Service
              </Text>
              <Box w="100%">
                <Image src={neoBankImage} alt="" />
              </Box>
            </Box>
          </SlideFade>
          <SlideFade
            in={true}
            offsetY="50px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box>
              <Text
                maxW="490px"
                textStyle="paragraph"
                mb="28px"
                fontSize={["14px", null, null, "21px"]}
                fontWeight="300"
                textAlign={["center", null, null, "left"]}
                mt={["40px", null, null, "unset"]}
                px={["16px", null, null, "0"]}
                lineHeight="1.3"
              >
                Design, build and launch a neo bank at reduced cost and risk
                with a single technology offering. Work with a cloud-based
                infrastructure, a rich set of APIs, and secured DevOps to enable
                seamless digital experiences.
              </Text>
              <Flex
                align="center"
                justify={["center", null, null, "left"]}
                mb={["80px", null, null, "unset"]}
                cursor="pointer"
                onClick={() =>
                  handleOpenWatchVideoModal(
                    "https://www.youtube.com/embed/OSerkQYuzjg"
                  )
                }
              >
                <Box
                  w={["16px", null, null, "auto"]}
                  height={["20px", null, null, "34px"]}
                >
                  <Image src={playCircleIcon} alt="" />
                </Box>
                <Text
                  textStyle="paragraph"
                  fontSize={["12px", null, null, "24px"]}
                  ml={["10px", null, null, "24px"]}
                  color="#2D4FA7"
                  fontWeight="bold"
                >
                  Watch intro
                </Text>
              </Flex>
            </Box>
          </SlideFade>
        </Flex>
        <Box
          height="1px"
          background="rgba(0, 0, 0, 0.15)"
          width="80%"
          mx="auto"
          my="75px"
          display={["none", null, null, "block"]}
        />
        <Flex
          align="center"
          justify="space-between"
          flexDir={["column", null, null, "row-reverse"]}
          px="16px"
        >
          <SlideFade
            in={true}
            offsetX="200px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box
              background="#fff"
              flex={["0 0 265px", null, null, "0 0 400px"]}
              maxW={["265px", null, null, "400px"]}
              p={["33px 27px", null, null, "50px 40px"]}
              borderRadius="20px"
              boxShadow="0px 0px 5px rgba(0, 0, 0, 0.25)"
            >
              <Text
                textStyle="paragraph"
                fontSize={["18px", null, null, "26px"]}
                color="#14142B"
                mb="10px"
              >
                Service
              </Text>
              <Text
                textStyle="h3"
                lineHeight="1.3"
                fontSize={["24px", null, null, "36px"]}
                fontWeight="bold"
                color="#102542"
                mb="40px"
              >
                Bank-API: <br /> Open Banking as a Service
              </Text>
              <Box w="100%">
                <Image src={bankApiImage} alt="" />
              </Box>
            </Box>
          </SlideFade>
          <SlideFade
            in={true}
            offsetY="50px"
            transition={{ enter: { duration: 1 } }}
          >
            <Box>
              <Text
                maxW="490px"
                textStyle="paragraph"
                mb="28px"
                fontSize={["14px", null, null, "21px"]}
                fontWeight="300"
                textAlign={["center", null, null, "left"]}
                mt={["40px", null, null, "unset"]}
                px={["16px", null, null, "0"]}
                lineHeight="1.3"
              >
                Experience the benefits of open banking without the extended
                timelines and complicated backend tasks. Gain free access to
                ready-made APIs, apps, and a customizable portal, to onboard
                your FinTech partners with ease!
              </Text>
              <Flex
                align="center"
                justify={["center", null, null, "left"]}
                mb={["80px", null, null, "unset"]}
                cursor="pointer"
                onClick={() =>
                  handleOpenWatchVideoModal(
                    "https://www.youtube.com/embed/NCyFlX9AFuQ"
                  )
                }
              >
                <Box
                  w={["16px", null, null, "auto"]}
                  height={["20px", null, null, "34px"]}
                >
                  <Image src={playCircleIcon} alt="" />
                </Box>
                <Text
                  textStyle="paragraph"
                  fontSize={["12px", null, null, "24px"]}
                  ml={["10px", null, null, "24px"]}
                  color="#2D4FA7"
                  fontWeight="bold"
                >
                  Watch intro
                </Text>
              </Flex>
            </Box>
          </SlideFade>
        </Flex>
      </Box>
      <Box
        pos="relative"
        w="100%"
        maxW="1200px"
        p={["0px", null, null, null, "0 0 200px"]}
      >
        <Flex
          justify={["center", null, null, "space-between"]}
          flexDir={["column", null, null, "row"]}
        >
          <Box
            pos="absolute"
            width={["290px", "auto"]}
            left={["-135px", "-359px"]}
            top={["62%", "0"]}
            zIndex="-1"
          >
            <Image src={bgCircle2} alt="101Pay" />
          </Box>
          <Box
            pos="absolute"
            width={["209px", "auto"]}
            right={["-50px", "-359px"]}
            bottom={["85%", "160px"]}
            zIndex="-1"
          >
            <Image src={bgCircle3} alt="101Pay" />
          </Box>
          {productsPreviewData.map((item, index) => (
            <>
              <Flex
                key={index}
                flexDir="column"
                mb={["70px", null, null, "unset"]}
                px="16px"
              >
                {item.key === "digibank" && (
                  <>
                    <Box
                      mx="auto"
                      mt={["-22px"]}
                      maxW={["250px", null, null, "470px"]}
                      mb={["0", null, null, "80px"]}
                    >
                      <Image src={item.logo} alt="101Pay" />
                    </Box>
                    <Box
                      order={[3, null, null, "unset"]}
                      maxW={["330px", null, null, "593px"]}
                      px="16px"
                      w={["100%", null, null, "unset"]}
                      mx={["auto", null, null, "unset"]}
                      mt={["70px", null, null, "30px"]}
                    >
                      <Image src={item.previewImage} alt={item.imageAltText} />
                    </Box>
                  </>
                )}
                {item.key === "101-pay" && (
                  <>
                    <Box
                      maxW={["142px", null, null, "260px"]}
                      mx="auto"
                      mb={["0", null, null, "80px"]}
                    >
                      <Image src={item.logo} alt="101Pay" />
                    </Box>
                    <Box
                      order={[3, null, null, "unset"]}
                      maxW={["200px", null, null, "268px"]}
                      mx={["auto"]}
                      mt={["70px", null, null, "0"]}
                    >
                      <Image src={item.previewImage} alt={item.imageAltText} />
                    </Box>
                  </>
                )}
                <Text
                  color="#777"
                  fontSize={["14px", null, null, "21px"]}
                  fontWeight="300"
                  maxW={[
                    "300px",
                    null,
                    null,
                    item.key === "digibank" ? "555px" : "490px",
                  ]}
                  mt={[
                    "0",
                    null,
                    null,
                    item.key === "digibank" ? "126px" : "50px",
                  ]}
                  mx={["auto", null, null, "unset"]}
                  mb={["20px", null, null, "unset"]}
                  textAlign={["center", null, null, "left"]}
                  order={[1, null, null, "unset"]}
                >
                  {item.description}
                </Text>
                <UnorderedList
                  order={[4, null, null, "unset"]}
                  listStyleType="none"
                  margin={["40px auto 0px", null, null, "40px 0 28px"]}
                  maxW={["340px", null, null, "unset"]}
                  px={["16px", null, null, "unset"]}
                >
                  {item.lists.map((list, indexList) => (
                    <ListItem
                      key={indexList}
                      display="flex"
                      alignItems="center"
                      color="#2D4FA7"
                      fontSize={["14px", null, null, "24px"]}
                      mb="12px"
                    >
                      <Box mr="12px" flex="0 0 24px" maxW="24px" height="28px">
                        <Image src={iconCheck} alt="" />
                      </Box>
                      {list}
                    </ListItem>
                  ))}
                </UnorderedList>
                {item.link && (
                  <Flex
                    align="center"
                    justify={["center", null, null, "left"]}
                    mb={["0", null, null, "unset"]}
                    order={[2, null, null, "unset"]}
                    cursor="pointer"
                    onClick={() => handleOpenWatchVideoModal(item.link)}
                  >
                    <Box
                      w={["16px", null, null, "auto"]}
                      height={["18px", null, null, "35px"]}
                    >
                      <Image src={playCircleIcon} alt="" />
                    </Box>
                    <Text
                      textStyle="paragraph"
                      fontSize={["12px", null, null, "24px"]}
                      ml={["10px", null, null, "24px"]}
                      color="#2D4FA7"
                      fontWeight="bold"
                    >
                      Watch intro
                    </Text>
                  </Flex>
                )}
              </Flex>
              {index === 0 && (
                <Box
                  minheight="900px"
                  background="rgba(0, 0, 0, 0.15)"
                  width="1px"
                  display={["none", null, null, "block"]}
                />
              )}
            </>
          ))}
        </Flex>
      </Box>
      <Text
        as="h2"
        textStyle="h2"
        fontSize={["18px", null, null, null, null, "48px"]}
        fontWeight="300"
        mb={["20px", null, null, null, null, "27px"]}
      >
        Partnership Approach
      </Text>
      <Text
        textStyle="paragraph"
        textAlign="center"
        fontWeight="300"
        mb={["54.66px", null, null, null, null, "108px"]}
      >
        Three simple steps to create the perfect digital products!
      </Text>
      <Flex
        flexDir={["column", null, null, null, null, "row"]}
        maxWidth="1163px"
        width="100%"
        mb={["56.25px", null, null, null, null, "72px"]}
        px={["66px", null, null, null, null, "16px"]}
      >
        {boxes.map((box, index) => (
          <Box
            key={box.title}
            padding={[
              "30.79px 0px 23.37px",
              null,
              null,
              null,
              null,
              "46px 0px 36px",
            ]}
            flex={["0 1 auto", null, null, null, null, "1"]}
            borderRadius={["6px", null, null, null, null, "10px"]}
            border={["none", null, null, null, null, "1px solid #2D4FA7"]}
            boxShadow={[
              "0px 0px 12px rgba(0, 0, 0, 0.1)",
              null,
              null,
              null,
              null,
              "none",
            ]}
            pos="relative"
            mx={["0px", null, null, null, null, index === 1 ? "16px" : 0]}
            my={[index === 1 ? "54px" : 0, null, null, null, null, 0]}
          >
            <Flex
              w={["49.46px", null, null, null, null, "76px"]}
              h={["49.46px", null, null, null, null, "76px"]}
              borderRadius="50%"
              bgColor="white"
              fontSize={["14px", null, null, null, null, "36px"]}
              lineHeight={["15.87px", null, null, null, null, "24.13px"]}
              fontWeight="700"
              color="primary"
              justify="center"
              alignItems="center"
              pos="absolute"
              top="0"
              left="50%"
              transform="translate(-50%, -50%)"
              boxShadow={[
                "0px 0px 2.6313px rgba(0, 0, 0, 0.25)",
                null,
                null,
                null,
                null,
                "0px 0px 4px rgba(0, 0, 0, 0.25)",
              ]}
            >
              {index + 1}
            </Flex>
            <Text
              color="secondary"
              textAlign="center"
              fontSize={["14px", null, null, null, null, "23.12px"]}
              lineHeight={["22.22px", null, null, null, null, "33.78px"]}
              mb={["11.62px", null, null, null, null, "16px"]}
              fontWeight="700"
            >
              {box.title}
            </Text>
            <Text
              color="primary"
              textAlign="center"
              fontSize={["14px", null, null, null, null, "22px"]}
              lineHeight={["19.73px", null, null, null, null, "30px"]}
              fontWeight="400"
              px={["22px", null, null, null, null, "28px"]}
            >
              {box.description}
            </Text>
          </Box>
        ))}
      </Flex>
      <Button
        href="#"
        w={["calc(100% - 84px)", null, null, null, null, "100%"]}
        mx="auto"
        maxW="444px"
        mb={["94px", null, null, null, null, "99px"]}
        onClick={() => router.push("/approach")}
      >
        Understand our approach
      </Button>
    </Layout>
  );
};

export default Products;
